import { PropsWithChildren } from 'react'

type FooterRightProps = {}

export const FooterRight = ({
  children
}: PropsWithChildren<FooterRightProps>) => {
  return <div className="ml-auto flex flex-row gap-4">{children}</div>
}
